/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';

export interface IBusinessSignUpErrorProps {
    id?: string;
    className: string;
    /** page | item */
    type?: string;
    /** danger, info, success */
    variant?: 'danger' | 'info' | 'success';
    message?: string;
}

export const SignUpError: React.FC<IBusinessSignUpErrorProps> = ({ id, className, type = 'page', variant = 'danger', message }) => {
    // page-level should be block__page-<variant>
    // item-level keeps passed className pattern block__form-item-item-<variant>
    const baseClassName = type === 'page' ? `${className}__page-${variant}` : `${className}-${type}-${variant}`;
    const isAlert = variant === 'danger';
    const role = isAlert ? 'alert' : 'status';
    const ariaLive = isAlert ? 'assertive' : 'polite';

    // For page-level common errors use platform alert classes directly
    if (type === 'page') {
        return (
            <div id={id} className={`msc-alert msc-alert-${variant}`} role={role} aria-live={ariaLive} aria-label={message}>
                <p>{message}</p>
            </div>
        );
    }

    return (
        <div id={id} className={baseClassName} role={role} aria-live={ariaLive} aria-label={message}>
            <p className={`${baseClassName}-text`}>{message}</p>
        </div>
    );
};

export default SignUpError;
